import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { connectorConfig } from '@dataconnect/generated';
import { configureUi, installChunkReload } from '@classroom-ai/ui';
import { ErrorBoundary } from '@classroom-ai/ui/routes/components';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';
import { getDataConnect, connectDataConnectEmulator } from 'firebase/data-connect';

import App from './app';
import { CONFIG } from './global-config';
import { routesSection } from './routes/sections';

// ----------------------------------------------------------------------

// Reload once if a lazy route chunk is stale after a hosting deploy (see packages/ui/src/chunk-reload.ts).
installChunkReload();

// Local dev only (VITE_USE_EMULATORS=true): route Data Connect to the emulator.
// Auth/storage emulators are wired in @classroom-ai/firebase-config. Port matches
// firebase.json. No-op in normal dev/prod.
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectDataConnectEmulator(getDataConnect(connectorConfig), 'localhost', 9399);
}

// Route defaults in the ui package already match this app's paths.
configureUi({ appName: CONFIG.appName, appVersion: CONFIG.appVersion });

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
